export default __webpack_public_path__ + "static/media/gb.3b671736.svg";